// src/api/userGoalApi.js
import axios from 'axios';
import api from './client'; // Import the shared client

export function addEntry(goalId, description) {
  return api.post(`users/goals/${goalId}/entries`, { description });
}

export function renameEntry(entryId, newDescription) {
  return api.put(`users/entries/${entryId}`, { description: newDescription });
}

export function deleteEntry(entryId) {
  return api.delete(`users/entries/${entryId}`);
}
